'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-info-box',
    cnBox = "".concat(CLASSNAME, "__box"),
    cnSuccess = "".concat(cnBox, "--success"),
    cnWarning = "".concat(cnBox, "--warning"),
    cnError = "".concat(cnBox, "--error"),
    cnInfo = "".concat(cnBox, "--info"),
    cnIcon = 'icon',
    cnContent = 'content';
/**
 * 
 * @param {*} param0 
 */

function InfoBox(_ref) {
  var content = _ref.content,
      iconId = _ref.iconId,
      title = _ref.title,
      type = _ref.type,
      withIcon = _ref.withIcon;
  var typeClass = cnInfo;
  var icon = 'check';

  switch (type) {
    case 'success':
      typeClass = cnSuccess;
      icon = 'check';
      break;

    case 'warning':
      typeClass = cnWarning;
      icon = 'info';
      break;

    case 'error':
      typeClass = cnError;
      icon = 'times';
      break;

    case 'info':
      typeClass = cnInfo;
      icon = 'info';
      break;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnBox, typeClass)
  }, (withIcon || iconId) && /*#__PURE__*/React__default.createElement(Icon, {
    id: iconId !== null && iconId !== void 0 ? iconId : icon,
    size: "sm",
    className: cnIcon
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cnContent
  }, /*#__PURE__*/React__default.createElement(Headline, {
    level: 2
  }, title), /*#__PURE__*/React__default.createElement(RichText, {
    content: content
  })));
}
InfoBox.propTypes = {
  /** Content of box */
  content: PropTypes.string,

  /** Id of custom icon */
  iconId: PropTypes.string,

  /** Title of box */
  title: PropTypes.string,

  /** Type that sets the color and icon */
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info']),

  /** Option to not display any icon */
  withIcon: PropTypes.bool
};
InfoBox.defaultProps = {
  type: 'info',
  withIcon: true
};

module.exports = InfoBox;
